





































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import ViewAction from "@/data/ViewAction";
import collections from "@/network/collections";
import FurnitureEditCard from "@/components/FurnitureEditCard.vue";
import UnsavedDialog from "@/components/FurnitureCardUnsavedDialog.vue";
import { Furniture } from "@/data/Furniture";

@Component({ components: { FurnitureEditCard, UnsavedDialog } })
export default class FurnitureCardDialog extends Vue {
  @Prop({})
  readonly current!: Furniture;

  @Prop({ default: false })
  readonly dialog!: boolean;

  @Prop({})
  readonly collection!: collections;

  @Prop({ default: false })
  readonly readonly!: boolean;

  @Prop({ default: false })
  readonly isAdd!: boolean;

  @Prop({})
  readonly menuActions!: ViewAction[];

  @Prop({ default: false })
  readonly menuLoading!: boolean;

  updates: Partial<Furniture> = {};

  updatesLoading = false;

  unsavedDialog = false;

  isEdit = false;

  get updatesLength(): number {
    return Object.keys(this.updates).length;
  }

  /**
   * Watch for change in dialog; if it opens, set isEdit to isAdd
   */
  @Watch("dialog")
  onDialogChanged(val: boolean): void {
    if (val) this.isEdit = this.isAdd;
  }

  /**
   * Add updates
   */
  addUpdates(updates: Partial<Furniture>): void {
    this.updates = { ...this.updates, ...updates };
  }

  /**
   * Clears updates object
   */
  clearUpdates(): void {
    this.updates = {};
  }

  /**
   * Exits dialog and clears the current item
   */
  closeDialog(forceClose = false): void {
    if (this.updatesLoading) {
      return;
    }
    if (this.updatesLength === 0 || forceClose) {
      this.unsavedDialog = false;
      this.isEdit = false;
      this.clearUpdates();
      this.$emit("close");
    } else {
      this.unsavedDialog = true;
    }
  }

  /**
   * Toggles edit state `isEdit` and clears update if setting `isEdit`
   * to false
   */
  toggleEdit(): void {
    if (this.isEdit) {
      this.clearUpdates();
    }
    this.isEdit = !this.isEdit;
  }

  /**
   * Commits updates to Firestore
   */
  saveChanges(): void {
    this.$emit("save-changes", this.updates);
    this.clearUpdates();
    this.isEdit = false;
  }
}
